<template>
  <div>
    <Notice :new-title="noticeTitle" v-if="show === 0"></Notice>
    <bGround v-else-if="show === 1" :title="title" :bg="bg" :bgVideo="bgVideo"></bGround>
  </div>
</template>

<script>
import Notice from '@/components/notice'
import bGround from '@/components/bGround'
import { getNavList } from '../axios/api'
export default {
  name: 'bgCotainerComponent',
  components: {
    Notice,
    bGround
  },
  data () {
    return {
      show: 1,
      bg: '',
      bgVideo: '',
      title: '',
      searchResult: {}
    }
  },
  props: {
    noticeTitle: String
  },
  watch: {
    $route (to, from) {
      this.showBG(to)
    }
  },
  mounted () {
    // window.translate.request.api.host = 'https://tr.yuenlongbarrage.hk/' // 将这里面的ip地址换成你服务器的ip，注意开头，及结尾还有个 / 别拉下
    // // 指定翻译服务为使用 translate.service
    // window.translate.execute()
  },
  created () {
    this.getNavList()
  },
  methods: {
    getNavList () {
      getNavList().then(res => {
        this.navList = res.data
        localStorage.setItem('menuList', JSON.stringify(res.data))
        this.showBG(this.$route)
      })
    },
    deepSearch (arr, targetId) {
      for (const item of arr) {
        if (Number(item.type_id) === Number(targetId)) {
          return item // 当前项匹配，直接返回
        }
        if (item.child) {
          const foundInChild = this.deepSearch(item.child, targetId) // 递归搜索子项
          if (foundInChild) {
            return foundInChild // 子项中找到，返回结果
          }
        }
      }
      return undefined // 遍历结束未找到
    },
    showBG (route) {
      console.log(route, '=================')
      if (route.name === 'index') {
        this.show = 0
        return
      }

      const menuRaw = localStorage.getItem('menuList')
      const menuList = menuRaw ? JSON.parse(menuRaw) : []
      const typeId = route.query.type_id
      this.searchResult = Array.isArray(menuList)
        ? this.deepSearch(menuList, typeId)
        : undefined
      this.show = 1

      if (!this.searchResult) {
        this.bg = ''
        this.bgVideo = ''
        this.title = route.meta && route.meta.tab ? route.meta.tab : 'STEAM Zone'
        return
      }

      this.bg = this.searchResult.headpic || ''
      this.bgVideo = this.searchResult.headmov || ''

      const langTmp = localStorage.getItem('to')
      if (langTmp === 'english') {
        this.title = this.searchResult.en_name || ''
      } else if (langTmp === 'chinese_simplified') {
        this.title = this.searchResult.nav_name || ''
      } else if (langTmp === 'chinese_traditional') {
        this.title = this.searchResult.tc_name || ''
      }
      // window.translate.execute()
    }
  }
}
</script>

<style scoped>

</style>
